var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: !0 });
import { ref, createApp, createVNode, watch, nextTick, isVNode } from "vue";
import { resolveVNode } from "../../../lib/utils.js";
import _sfc_main from "../alert-dialog/core/AlertDialog.js";
import _sfc_main$7 from "../alert-dialog/core/AlertDialogAction.js";
import _sfc_main$6 from "../alert-dialog/core/AlertDialogCancel.js";
import _sfc_main$1 from "../alert-dialog/core/AlertDialogContent.js";
import _sfc_main$4 from "../alert-dialog/core/AlertDialogDescription.js";
import _sfc_main$5 from "../alert-dialog/core/AlertDialogFooter.js";
import _sfc_main$2 from "../alert-dialog/core/AlertDialogHeader.js";
import _sfc_main$3 from "../alert-dialog/core/AlertDialogTitle.js";
import "../../../node_modules/.pnpm/@uppy_locales@4.5.2/node_modules/@uppy/locales/lib/en_US.js";
function _isSlot(s) {
  return typeof s == "function" || Object.prototype.toString.call(s) === "[object Object]" && !isVNode(s);
}
__name(_isSlot, "_isSlot");
const modalFunctions = {
  /**
   * @param {ModalType} type
   * @param {ModalOptions} options
   */
  create(type, options) {
    const container = document.createElement("div");
    document.body.appendChild(container);
    const {
      title = "",
      content = "",
      cancelText = null,
      okText = null,
      onCancel,
      onOk
    } = options, openRef = ref(!1);
    let closeInstance = null;
    function handleCancel() {
      openRef.value = !1, onCancel == null || onCancel();
    }
    __name(handleCancel, "handleCancel");
    function handleOk() {
      openRef.value = !1, onOk == null || onOk();
    }
    __name(handleOk, "handleOk");
    function closeFunc() {
      openRef.value = !1;
    }
    __name(closeFunc, "closeFunc");
    function getActionClass() {
      return type === "danger" ? "bg-destructive hover:bg-destructive/90" : "bg-primary hover:bg-primary/90";
    }
    __name(getActionClass, "getActionClass");
    const modalApp = createApp({
      setup() {
        closeInstance = closeFunc, watch(openRef, (newOpenVal) => {
          newOpenVal || setTimeout(() => {
            modalApp.unmount(), container.remove();
          }, 150);
        });
      },
      render() {
        let _slot, _slot2, _slot3, _slot4;
        return createVNode(_sfc_main, {
          open: openRef.value,
          "onUpdate:open": /* @__PURE__ */ __name(($event) => openRef.value = $event, "onUpdate:open")
        }, {
          default: /* @__PURE__ */ __name(() => [createVNode(_sfc_main$1, null, {
            default: /* @__PURE__ */ __name(() => [createVNode(_sfc_main$2, null, {
              default: /* @__PURE__ */ __name(() => [createVNode(_sfc_main$3, null, _isSlot(_slot = resolveVNode(title)) ? _slot : {
                default: /* @__PURE__ */ __name(() => [_slot], "default")
              }), content ? createVNode(_sfc_main$4, null, _isSlot(_slot2 = resolveVNode(content)) ? _slot2 : {
                default: /* @__PURE__ */ __name(() => [_slot2], "default")
              }) : null], "default")
            }), createVNode(_sfc_main$5, null, {
              default: /* @__PURE__ */ __name(() => [cancelText !== null ? createVNode(_sfc_main$6, {
                onClick: handleCancel
              }, _isSlot(_slot3 = resolveVNode(cancelText)) ? _slot3 : {
                default: /* @__PURE__ */ __name(() => [_slot3], "default")
              }) : null, okText !== null ? createVNode(_sfc_main$7, {
                class: getActionClass(),
                onClick: handleOk
              }, _isSlot(_slot4 = resolveVNode(okText)) ? _slot4 : {
                default: /* @__PURE__ */ __name(() => [_slot4], "default")
              }) : null], "default")
            })], "default")
          })], "default")
        });
      }
    });
    return modalApp.mount(container), nextTick(() => {
      openRef.value = !0;
    }), {
      close: /* @__PURE__ */ __name(() => {
        closeInstance == null || closeInstance();
      }, "close")
    };
  },
  /**
   * @param options
   */
  info(options) {
    return this.create("info", options);
  },
  /**
   * @param options
   */
  danger(options) {
    return this.create("danger", options);
  }
};
export {
  modalFunctions
};
//# sourceMappingURL=modal.js.map
